import React, { useState } from 'react';
import ThemeContext from '../context/theme.Context';

const ThemeProvider = ({ children }) => {

    /**
     * Theme details state / controls
     */
    const setTheme = (
        newTheme
    ) => {
        updateTheme(prevState => {

            var newThemeState;

            if (newTheme === 'light') {
                newThemeState = {
                    ...prevState, theme: 'light', textColor: 'dark', bodyBackground: '#f8f9fa', logo: 'logo-black.svg'
                };
            }
            else {
                newThemeState = {
                    ...prevState, theme: 'dark', textColor: 'light', bodyBackground: '#343a40', logo: 'logo-white.svg'
                };
            }


            document.body.style.backgroundColor = newThemeState.bodyBackground;
            return newThemeState;
        });
    };

    const initialThemeState = {
        theme: 'dark',
        textColor: 'light',
        bodyBackground: '#343a40',
        logo: 'logo-white.svg',
        setTheme
    };

    function getInitialState() {
        var theme;
        try {
            const fromLocalStorage = JSON.parse(localStorage.getItem('theme'));
            if (fromLocalStorage) {
                theme = { ...fromLocalStorage, setTheme };
            }
            theme = theme || initialThemeState;
            if (!theme.logo)
                theme.logo = initialThemeState.logo;
            document.body.style.backgroundColor = theme.bodyBackground;
            return theme;
        }
        catch (error) {
            document.body.style.backgroundColor = initialThemeState.bodyBackground;
            return initialThemeState;
        }

    }

    const [currentTheme, updateTheme] = useState(getInitialState);

    React.useEffect(() => {
        localStorage.setItem('theme', JSON.stringify(currentTheme));
    }, [currentTheme]);


    return (
        <ThemeContext.Provider value={currentTheme}>
            {children}
        </ThemeContext.Provider>
    );
};

export default ThemeProvider;


// WEBPACK FOOTER //
// ./src/components/ThemeProvider.js